import { useNavigate } from "react-router-dom";
import { DownArrowIconBlue } from "../../assets/Icon/ArrowIcon";
import {
  AgentsIcon,
  AgentsIconBlue,
  BillingIcon,
  BillingIconBlue,
  BrifcaseIcon,
  BrifcaseIconBlue,
  ComplianceIcon,
  ComplianceIconBlue,
  DashboardIconBlue,
  DashboardIconWhite,
  EarnIcon,
  EarnIconBlue,
  HomeIconblue,
  HomeIconWhite,
  ITINn,
  ITINnBlue,
  ToolsIcon,
  ToolsIconBlue,
  UserIconBlue,
  UserIconWhite,
} from "../../assets/Icon/headerCicon";

export const member = [
  { name: "Single Member", id: 1 },
  { name: "Multimember", id: 2 },
];

export const annual_revenue = [
  { id: 1, name: "0-10k Annually", value: "0-10k", isChecked: false },
  { id: 2, name: "10k-20k Annually", value: "10k-20k", isChecked: false },
  { id: 3, name: "20k-50k Annually", value: "20k-50k", isChecked: false },
  { id: 4, name: "50k-100k Annually", value: "50k-100k", isChecked: false },
];
export const employees_count = [
  { id: 1, name: "0-5", value: "5", isChecked: false },
  { id: 2, name: "5-10", value: "5-10", isChecked: false },
  { id: 3, name: "11-20", value: "11-20", isChecked: false },
  { id: 4, name: "21-50", value: "21-50", isChecked: false },
  { id: 5, name: "51-100", value: "51-100", isChecked: false },
];

export const company_type = [
  { id: 1, name: "Single-Member LLC", value: "1", isChecked: false },
  { id: 2, name: "Multi-Member LLC", value: "2", isChecked: false },
  { id: 3, name: "Corporation (C-Corp)", value: "3", isChecked: false },
];

